<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          customers = data
          this.isLoading = false
        }
      "
      contentId="customers"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Clients</div>
    </div>
    <div class="py-2"></div>

    <div class="relative" v-if="isLoading || customers.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
          >
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              Client
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Date de création
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">Total dépensé</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Dernier paiement
            </div>

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div
            v-for="(customer, index) in isLoading
              ? shimmerCustomers
              : customers"
            :key="index"
            :class="{ shimmerElement: customer.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              <img
                :src="customer.image"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-xl"
              />
              <div class="w-[16rem]">
                <h3 class="font-semibold title-color truncate">
                  {{ customer.name }}
                </h3>
                <p class="truncate text-sm">
                  {{ customer.email }}
                </p>
                <p class="truncate text-sm">#{{ customer.id }}</p>
              </div>
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(customer.createdAt, 'DD MMM YYYY') }}
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.formatAmount(customer.totalOrdersAmount || 0) }}
              FCFA
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(customer.lastOrder, 'DD MMM YYYY') }}
            </div>

            <!-- SKU -->
            <!-- <div class=" text-gray-700">{{ customer.sku }}</div> -->

            <!-- Actions -->
            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              <!-- <button
            class="px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
          >
            Supprimer
          </button> -->
              <DropdownComponent
                :selects="[
                  {
                    name: 'Supprimer',
                    onClick() {
                      $Events.dispatchEvent('customer_deletion_requested', {
                        customer,
                      })
                    },
                  },
                  { name: 'Envoyer demande de paiement' },
                ]"
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/no-user.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun client</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Pas de client dans votre boutique. <br />
          Vos clients s'afficheront ici.
        </div>
      </div>
    </div>
    <EventListener
      :events="['customer_deletion_done', 'customer_deletion_failed']"
      @customer_deletion_done="onCustomerDeleted"
      @customer_deletion_failed="onCustomerDeletionFailed"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '@/components/utils/DotLottieComponent.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    DotLottieComponent,
    EventListener,
  },
  data() {
    return {
      eventsIds: [],
      customers: [],
      activeTab: 'home',
      isLoading: true,
      shimmerCustomers: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
    onCustomerDeleted() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'Le client a été supprimé avec succès',
      })
    },
    onCustomerDeletionFailed(response) {
      let message = 'Echec lors de la supression du client'
      if (response.customerNotFound) message = "Ce client n'est plus enrégistré"
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echoué',
        body: message,
      })
    },
  },
}
</script>
